import { token } from '@atlaskit/tokens';
import { lightSelectOptionColors, type SelectOptionColor } from '@databases/model/field';
import {
  mapColorToNewPalette,
  mapDarkColorToLight
} from '@databases/utils/database/field-types/select';

import { isFeatureFlagEnabled } from '@canvas/client-feature-flags';

import { paletteColorsMap, type ColorPalette } from './types.ts';

export const newBackgroundColors: Record<string, string> = {
  grey: token('color.background.accent.gray.subtler.hovered'),
  blue: token('color.background.accent.blue.subtler.hovered'),
  teal: token('color.background.accent.teal.subtler.hovered'),
  red: token('color.background.accent.red.subtler.hovered'),
  green: token('color.background.accent.green.subtler.hovered'),
  purple: token('color.background.accent.purple.subtler.hovered'),
  lime: token('color.background.accent.lime.subtler.hovered'),
  magenta: token('color.background.accent.magenta.subtler.hovered'),
  orange: token('color.background.accent.orange.subtler.hovered'),
  yellow: token('color.background.accent.yellow.subtler.hovered'),

  blueLight: token('color.background.accent.blue.subtlest'),
  redLight: token('color.background.accent.red.subtlest'),
  yellowLight: token('color.background.accent.yellow.subtlest'),
  greenLight: token('color.background.accent.green.subtlest'),
  tealLight: token('color.background.accent.teal.subtlest'),
  purpleLight: token('color.background.accent.purple.subtlest'),
  limeLight: token('color.background.accent.lime.subtlest'),
  magentaLight: token('color.background.accent.magenta.subtlest'),
  orangeLight: token('color.background.accent.orange.subtlest'),
  greyLight: token('color.background.accent.gray.subtlest')
};

export const newBorderColors: Record<string, string> = {
  grey: token('color.background.accent.gray.subtler.hovered'),
  blue: token('color.background.accent.blue.subtler.hovered'),
  teal: token('color.background.accent.teal.subtler.hovered'),
  red: token('color.background.accent.red.subtler.hovered'),
  green: token('color.background.accent.green.subtler.hovered'),
  purple: token('color.background.accent.purple.subtler.hovered'),
  lime: token('color.background.accent.lime.subtler.hovered'),
  magenta: token('color.background.accent.magenta.subtler.hovered'),
  orange: token('color.background.accent.orange.subtler.hovered'),
  yellow: token('color.background.accent.yellow.subtler.hovered'),

  blueLight: '#669DF1',
  redLight: '#F87168',
  yellowLight: '#DDB30E',
  greenLight: '#4BCE97',
  tealLight: '#6CC3E0',
  purpleLight: '#C97CF4',
  limeLight: '#94C748',
  magentaLight: '#E774BB',
  orangeLight: '#FCA700',
  greyLight: '#B7B9BE'
};

export const newTextColors: Record<string, string> = {
  blue: token('color.text'),
  red: token('color.text'),
  yellow: token('color.text'),
  green: token('color.text'),
  teal: token('color.text'),
  purple: token('color.text'),
  lime: token('color.text'),
  magenta: token('color.text'),
  orange: token('color.text'),
  grey: token('color.text'),

  blueLight: token('color.text'),
  redLight: token('color.text'),
  yellowLight: token('color.text'),
  greenLight: token('color.text'),
  tealLight: token('color.text'),
  purpleLight: token('color.text'),
  limeLight: token('color.text'),
  magentaLight: token('color.text'),
  orangeLight: token('color.text'),
  greyLight: token('color.text')
};

export const TagColorPaletteADSRefresh: ColorPalette<SelectOptionColor> = {
  borderColor: (color) => {
    const effectiveColor = isFeatureFlagEnabled('platformLozengeTagBadgeVisualUplifts')
      ? mapDarkColorToLight(color)
      : color;
    const mappedColor = mapColorToNewPalette(effectiveColor);
    return newBorderColors[mappedColor];
  },
  backgroundColor: (color) => {
    const effectiveColor = isFeatureFlagEnabled('platformLozengeTagBadgeVisualUplifts')
      ? mapDarkColorToLight(color)
      : color;
    const mappedColor = mapColorToNewPalette(effectiveColor);
    return newBackgroundColors[mappedColor];
  },
  textColor: (color) => {
    const effectiveColor = isFeatureFlagEnabled('platformLozengeTagBadgeVisualUplifts')
      ? mapDarkColorToLight(color)
      : color;
    const mappedColor = mapColorToNewPalette(effectiveColor);
    return newTextColors[mappedColor];
  },
  swatch: () => {
    return isFeatureFlagEnabled('platformLozengeTagBadgeVisualUplifts')
      ? lightSelectOptionColors
      : Object.keys(paletteColorsMap);
  }
};
